import { put, takeLatest } from 'redux-saga/effects'

import {
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR
}
  from '../../actions/auth'

function * logoutSaga (action) {
  try {
    yield put({ type: LOGOUT_SUCCESS, payload: null })

    if (action?.payload?.clearLocalStorage) {
      localStorage.removeItem('lastSelectedVenue')
      localStorage.removeItem('venues')
      localStorage.removeItem('mylocation')
    }
  } catch (error) {
    console.log(error)
    const errorMessage = { code: error.code, message: error.message }

    yield put({ type: LOGOUT_ERROR, error: errorMessage })
  }
}

export function * logoutWatcher () {
  yield takeLatest(LOGOUT, logoutSaga)
}
